import styled from 'styled-components';
import breakpoint from '../breakpoints';

const trackingToLetterSpacing = (spacing) => `${spacing/1000}em`;

export default {
  Wrapper: styled.div`
    position: relative;
    overflow: hidden;
  `,
  Content: styled.div`
    text-align: center;
    display: block;
    width: 100%;
    max-width: 800px;
    box-sizing: border-box;
    padding: 40px 20px;
    ${breakpoint('tablet', 'up')} {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate3d(-50%, -50%, 0);
      color: #FFF;
    }
    ${breakpoint('mobile')}{
      width: 90%;
      margin: 0 auto;
      padding: 20px 0;
      border-bottom: 1px solid #ccc;
    }
  `,
  Heading1: styled.h1`
    font-family: 'ToyotaType Semibold';
    font-weight: bold;
    letter-spacing: ${trackingToLetterSpacing(50)};

    font-size: 24px;
    line-height: 32px;
    ${breakpoint('tablet', 'up')} {
      font-size: 40px;
      line-height: 32px;
    }
    ${breakpoint('mobile')}{
      font-size: 28px;
    }
  `,
  Fingerprint: styled.div`
    position: absolute;
    top: 50%;
    right: 3%;
    width: 58vw;
    transform: translate3d(0, -50%, 0);
    img {
      width: 100%;
      display: block;
    }
  `,
  FingerprintRight: styled.div`
    position: absolute;
    top: 50%;
    right: -19%;
    width: 58vw;
    transform:translate3d(0, -50%, 0);
    img {
      transform: rotate(180deg);
      width: 100%;
      display: block;
    }
  `,
  Image: styled.div`
    display: block;
    position: relative;
    background: #cc1d00;
    padding-top: calc(224/375 * 100%);

    ${breakpoint('tablet', 'up')} {
      padding-top: calc(666/1440 * 100%);
    }

    img {
      width: 100%;
      display: block;
      pointer-events: none;
      position: absolute;
      left: 0;
      top: 0;
    }
  `,
};
